import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IPoderJudicialCreateReportResponse, IPoderJudicialCivil, IPoderJudicialLaboral, IPoderJudicialCobranza } from 'src/app/interface/IPoderJudicialCreateReportResponse';
import { EIndexPoderJudicial } from 'src/app/enum/EIndexPoderJudicial';
import { environment as env } from 'src/environments/environment';
import { ReporteJudicialService } from 'src/app/shared/services/reporte-judicial.service';
import { AlertService } from 'src/app/components/_alert/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as uuid from 'uuid';

@Component({
  selector: 'app-poder-judicial-report-viewer',
  templateUrl: './poder-judicial-report-viewer.component.html',
  styleUrls: ['./poder-judicial-report-viewer.component.scss']
})
export class PoderJudicialReportViewerComponent implements OnInit {
  @Input() content!: IPoderJudicialCreateReportResponse;
  @Input() public showHeader: boolean = true;
  @Input() fromConsolidado: boolean = false;
  @Input() fromModule: boolean = false;
  @Input() fromFlujoDeCredito: boolean = false;

  @Output() descargarTX = new EventEmitter<string>();
  @Output() volver = new EventEmitter<void>();

  public fechaExtraccion: string = '';
  public rutEmpresa: boolean = false;
  
  public civilCaseSelected: IPoderJudicialCivil | null = null;
  public laboralCaseSelected: IPoderJudicialLaboral | null = null;
  public cobranzaCaseSelected: IPoderJudicialCobranza | null = null;
  public displayedColumnsCausasCiviles: string[] = [
    'action',
    'rol',
    'fecha',
    'caratulado',
    'tribunal'
  ];
  public displayedColumnsCausasLaborales: string[] = [
    'action',
    'rit',
    'tribunal',
    'caratulado',
    'fecha_ingreso',
    'estado_causa'
  ];

  public displayedColumnsCausasCobranza: string[] = [
    'action',
    'rit',
    'ruc',
    'tribunal',
    'caratulado',
    'fecha_ingreso',
    'estado_causa'
  ];


  // Validate if the data source contains sections
  public hasCivil = false;
  public hasLaboral = false;
  public hasCobranza = false;

  // NavTabs details sections
  public navTabsCivil: any = [];
  public navTabsLaboral: any = [];
  public navTabsCobranza: any = [];
  public selectedCivilIndex = 0;
  public selectedLaboralIndex = 0;
  public selectedCobranzaIndex = 0;

  // counters on the report top
  public totalCivil = 0;
  public totalLaboral = 0;
  public totalCobranza = 0;
  // By default is Zero, and green
  public totalTributario = 0;
  public contentShow = 'civiles';

  public detalleHeader: {title: string, value: string}[] = [];
  public idDetalle: string = '';
  public highlightedRowId: string | null = null;

  public paginated: boolean = false;
  public paginationOptions = env.itemPerPageOptions;
  public pageSize: number | null = null;
  public pageIndex: number = 0;
  public totalItems: number = 0;
  public idTransaccion: string = '';

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor(
    private _poderJudicialService: ReporteJudicialService,
    private spinner: NgxSpinnerService,
    public alertService: AlertService,
  ) { }

  ngOnInit(): void {
    if(this.fromModule) {
      // se debe validar si hay que paginar el contenido
      if(this.validatePagination()) {
        this.paginated = true;
        this.setContent();
        // inicializar paginación
        this.idTransaccion = this.content?.poderJudicialReporte?.datosBasicosSolicitud?.IDTransaccion || '';
        this.resetPagination();
      } else {
        this.paginated = false;
        this.setContent();
      }
    } else {
      this.setContent();
    }
  }
  
  resetPagination(): void {
    if (this.contentShow === 'tributario' || !this.paginated) {
      return;
    }

    const totalCases = this.contentShow === 'civiles' ? this.totalCivil
      : this.contentShow === 'laboral' ? this.totalLaboral
      : this.totalCobranza;

    const previousPageIndex = this.pageIndex;
    const previousPageSize = this.pageSize;

    this.pageIndex = 0;
    this.pageSize = 5; // SIEMPRE inicializa en 5
    this.totalItems = totalCases;

    // Siempre recarga la API al resetear la paginación
    if (previousPageIndex !== this.pageIndex || previousPageSize !== this.pageSize) {
      const pagina = this.pageIndex + 1;
      const tamanoPagina = this.pageSize;
      this.llamadaApi(pagina, tamanoPagina);
    }
  }
  
  setContent(): void {
    this.validateReportSections();
    this.setIdUnico();
  }

  validatePagination(): boolean {
    if(this.content?.poderJudicialReporte?.poderJudicial?.Totales?.reporteCompleto == 1 || this.content?.poderJudicialReporte?.poderJudicial?.Totales?.reporteCompleto == 0){ // indica si el reporte es completo o paginado
      return this.content.poderJudicialReporte.poderJudicial.Totales.reporteCompleto == 1 ? true : false;
    }
    return false; // por defecto no paginado
  }

  setTotales(): void {
    if(this.content?.poderJudicialReporte?.poderJudicial?.Totales){
      const { nCausasCivil, nCausasLaboral, nCausasCobranza } = this.content.poderJudicialReporte.poderJudicial.Totales;
      
      this.totalCivil = nCausasCivil || 0;
      this.totalLaboral = nCausasLaboral || 0;
      this.totalCobranza = nCausasCobranza || 0;
    }
  }

  setTipoRut(): void {
    const rut = this.content?.poderJudicialReporte?.datosBasicosSolicitud?.Rut || '';
    if(rut && Number(rut) >= 50000000) {
      this.rutEmpresa = true;
    } else {
      this.rutEmpresa = false;
    }
  }

  setFechaExtraccion(): void {
    const fechaCivil = this.content?.poderJudicialReporte?.poderJudicial?.Civil?.[0]?.fechaExtraccion || null;
    const fechaLaboral = this.content?.poderJudicialReporte?.poderJudicial?.Laboral?.[0]?.fechaExtraccion || null;
    const fechaCobranza = this.content?.poderJudicialReporte?.poderJudicial?.Cobranza?.[0]?.fechaExtraccion || null;
    if(fechaCivil) {
      this.fechaExtraccion = fechaCivil;
    } else if(fechaLaboral) {
      this.fechaExtraccion = fechaLaboral;
    } else if(fechaCobranza) {
      this.fechaExtraccion = fechaCobranza;
    } else {
      this.fechaExtraccion = '';
    }
  }

  public validateReportSections(): void {
    if(!this.content?.poderJudicialReporte?.poderJudicial || Object.keys(this.content?.poderJudicialReporte?.poderJudicial).length <= 0) {
      return;
    }

    const { Civil, Laboral, Cobranza } = this.content.poderJudicialReporte.poderJudicial;

    this.totalCivil = Civil?.length || 0;
    this.totalLaboral = Laboral?.length || 0;
    this.totalCobranza = Cobranza?.length || 0;

    this.hasCivil = this.totalCivil > 0;
    this.hasLaboral = this.totalLaboral > 0;
    this.hasCobranza = this.totalCobranza > 0;
  }

  setIdUnico(): void {
    if(this.hasCivil && this.content?.poderJudicialReporte?.poderJudicial?.Civil && this.content?.poderJudicialReporte?.poderJudicial?.Civil.length > 0) {
      for(const element of this.content.poderJudicialReporte.poderJudicial.Civil){
        element.id = uuid.v4();
      }
    }
    if(this.hasLaboral && this.content?.poderJudicialReporte?.poderJudicial?.Laboral && this.content?.poderJudicialReporte?.poderJudicial?.Laboral.length > 0) {
      for(const element of this.content.poderJudicialReporte.poderJudicial.Laboral){
        element.id = uuid.v4();
      }
    }
    if(this.hasCobranza && this.content?.poderJudicialReporte?.poderJudicial?.Cobranza && this.content?.poderJudicialReporte?.poderJudicial?.Cobranza.length > 0) {
      for(const element of this.content.poderJudicialReporte.poderJudicial.Cobranza){
        element.id = uuid.v4();
      }
    }

    this.loadNavTabsCivil();
    this.loadNavTabsLaboral();
    this.loadNavTabsCobranza();
    this.setTotales();
    this.setFechaExtraccion();
    this.setTipoRut();
  }

  public selectCivilCase(id: any, idHTML: string): void {
    const civilFound = this.content.poderJudicialReporte.poderJudicial.Civil.find(causa => causa.id === id);
    if (civilFound) {
      this.civilCaseSelected = this.civilCaseSelected && this.civilCaseSelected === civilFound? null: civilFound;
      this.setDetalleHeaderCivil(idHTML);
      this.loadTabData();
      this.civilCaseSelected ? this.scrollToId(idHTML) : null;
    }
  }

  public selectLaboralCase(id: any, idHTML: string): void {
    const laboralFound = this.content.poderJudicialReporte.poderJudicial.Laboral.find(causa => causa.id === id);
    if (laboralFound) {
      this.laboralCaseSelected = this.laboralCaseSelected && this.laboralCaseSelected === laboralFound? null: laboralFound;
      this.setDetalleHeaderLaboral(idHTML);
      this.loadTabData();
      this.laboralCaseSelected ? this.scrollToId(idHTML) : null;
    }
  }

  public selectCobranzaCase(id: any, idHTML: string): void {
    const cobranzaFound = this.content.poderJudicialReporte.poderJudicial.Cobranza.find(causa => causa.id === id);
    if (cobranzaFound) {
      this.cobranzaCaseSelected = this.cobranzaCaseSelected && this.cobranzaCaseSelected === cobranzaFound? null: cobranzaFound;
      this.setDetalleHeaderCobranza(idHTML);
      this.loadTabData();
      this.cobranzaCaseSelected ? this.scrollToId(idHTML) : null;
    }
  }

  setDetalleHeaderCivil(idHTML: string = ''): void {
    if(this.civilCaseSelected == null) {
      this.detalleHeader = [];
      this.idDetalle = '';
    } else {
      this.detalleHeader = [
        { title: 'ROL:', value: this.civilCaseSelected?.rol || this.civilCaseSelected?.details?.["ROL:"] },
        { title: 'Fecha Ingreso:', value: this.civilCaseSelected.fecha },
        { title: '', value: this.civilCaseSelected.caratulado },
        { title: 'Estado Adm.', value: this.civilCaseSelected.details["Est. Adm.:"] },
        { title: 'Procedimiento:', value: this.civilCaseSelected.details["Proc.:"] },
        { title: 'Ubicación:', value: this.civilCaseSelected.details["Ubicación:"] },
        { title: 'Estado Procedimiento:', value: this.civilCaseSelected.details["Proc.:"] },
        { title: 'Etapa:', value: this.civilCaseSelected.details["Etapa:"] },
        { title: 'Tribunal:', value: this.civilCaseSelected.details["Tribunal:"] }
      ];
      this.idDetalle = idHTML;
    }
  }

  setDetalleHeaderLaboral(idHTML: string = ''): void {
    if(this.laboralCaseSelected == null) {
      this.detalleHeader = [];
      this.idDetalle = '';
    } else {
      this.detalleHeader = [
        { title: 'RIT:', value: this.laboralCaseSelected.details["RIT :"] },
        { title: '', value: this.laboralCaseSelected.caratulado },
        { title: 'Fecha Ingreso:', value: this.laboralCaseSelected.details["F. Ing.:"] },
        { title: 'RUC.:', value: this.laboralCaseSelected.details["RUC :"] },
        { title: 'Procedimiento:', value: this.laboralCaseSelected.details["Proc.:"] },
        { title: 'Forma Inicio:', value: this.laboralCaseSelected.details["Forma Inicio:"] },
        { title: 'Est. Adm.:', value: this.laboralCaseSelected.details["Est. Adm.: "] },
        { title: 'Etapa:', value: this.laboralCaseSelected.details["Etapa:"] },
        { title: 'Estado Proc:', value: this.laboralCaseSelected.details["Estado Proc.:"] },
        { title: 'Tribunal:', value: this.laboralCaseSelected.details["Tribunal:"] },
      ];
      this.idDetalle = idHTML;
    }
  }

  setDetalleHeaderCobranza(idHTML: string = ''): void {
    if(this.cobranzaCaseSelected == null) {
      this.detalleHeader = [];
      this.idDetalle = '';
    } else {
      this.detalleHeader = [
        { title: 'RIT:', value: this.cobranzaCaseSelected.details["RIT:"] },
        { title: '', value: this.cobranzaCaseSelected.details["Juez Asignado:"] },
        { title: 'Fecha Ingreso:', value: this.cobranzaCaseSelected.details["Fecha Ing.:"] },
        { title: 'RUC.:', value: this.cobranzaCaseSelected.details["RUC :"] },
        { title: 'Est. Adm.:', value: this.cobranzaCaseSelected.details["Est.Adm.:"] },
        { title: 'Proc:', value: this.cobranzaCaseSelected.details["Proc.:"] },
        { title: 'Forma Inicio.:', value: this.cobranzaCaseSelected.details["Forma Inicio.:"] },
        { title: 'Estado Proc.:', value: this.cobranzaCaseSelected.details["Estado Proc.:"] },
        { title: 'Etapa:', value: this.cobranzaCaseSelected.details["Etapa:"] },
        { title: 'Juez Asignado.', value: this.cobranzaCaseSelected.details["Juez Asignado:"] },
        { title: 'Tribunal:', value: this.cobranzaCaseSelected.details["Tribunal:"] }
      ];
      this.idDetalle = idHTML;
    }
  }

  public setIndex(type: string, index: number): void {
    switch(type) {
      case EIndexPoderJudicial.CIVIL:
        this.selectedCivilIndex = index;
        return;
      case EIndexPoderJudicial.LABORAL:
        this.selectedLaboralIndex = index;
        return;
      case EIndexPoderJudicial.COBRANZA:
        this.selectedCobranzaIndex = index;
        return;
      default:
        return;
    }
  }

  public loadNavTabsCivil(): void {
    this.navTabsCivil = [
      {
          title: "Historia",
          content: [],
          displayColumns: ['folio','etapa','tramite','descTramite','fechaTramite','foja'],
          titleTable: ['Folio','Etapa','Trámite','Desc. Trámite','Fecha trámite','Foja']
      },
      {
          title: "Litigantes",
          content: [],
          displayColumns: ['participante','rut','razonSocial'],
          titleTable: ['participante', 'Rut', 'Nombre o Razón Social']
      },
      {
          title: "Notificaciones",
          content: [],
          displayColumns: ['rol','estNotif','tipoNotif','fechaTramite','tipoPart','nombre','tramite'],
          titleTable: ['ROL','Est. Notif.','Tipo Notif.','Fecha trámite','Tipo Part.','Nombre','Trámite']
      },
    ];
  }

  public loadNavTabsLaboral(): void {
    this.navTabsLaboral = [
      {
          title: "Movimientos",
          content: [],
          displayColumns: ['folio','etapa','tramite','descTramite','fechaTramite','estado'],
          titleTable: ['Folio','Etapa','Trámite','Desc. Trámite','Fecha trámite','Estado']
      },
      {
          title: "Litigantes",
          content: [],
          displayColumns: ['abogDefensor','sujeto','rut','persona','razonSocial'],
          titleTable: ['Abog. Defensor','Sujeto','Rut','Persona','Nombre o Razón Social']
      },
      {
          title: "Notificaciones",
          content: [],
          displayColumns: ['estNotif','rit','ruc','fechaTramite','tipoParte','nombre','tramite','obsFallida'],
          titleTable: ['Estado Notif.','RIT.','RUC','Fecha Trámite','Tipo Parte','Nombre','Trámite','Obs. Fallida']
      },
      {
          title: "Materias",
          content: [],
          displayColumns: ['codigo','glosaMateria'],
          titleTable: ['Código','Glosa de Materia']
      },
    ];
  }

  public loadNavTabsCobranza(): void {
    this.navTabsCobranza = [
      {
          title: "Historia",
          content: [],
          displayColumns: ['etapa','tramite','descTramite','estadoFirma','fechaTramite','georreferencia'],
          titleTable: ['Etapa','Trámite','Desc. Trámite','Estado Firma','Fecha trámite','Georreferencia']
      },
      {
          title: "Litigantes",
          content: [],
          displayColumns: ['sujero','rut','persona','razonSocial'],
          titleTable: ['Sujeto','Rut','Persona','Nombre o Razón Social']
      },
      {
          title: "Notificaciones",
          content: [],
          displayColumns: ['tipoNotif','estNotif','fechaNotif','fechaTramite','tramite','tipPart','nombre'],
          titleTable: ['Tipo Notif.','Esti. Notif.','Fecha Notif','Fecha Trámite','Trámite','Tipo Part.','Nombre']
      },
    ];
  }

  descargarPDF(): void {
    const tx = this.content?.poderJudicialReporte?.datosBasicosSolicitud?.IDTransaccion || '';
    if(tx) {
      this.descargarTX.emit(tx);
    }
  }

  getTabsList(): any[] {
    if(this.civilCaseSelected && this.hasCivil && this.contentShow === 'civiles') {
      return this.navTabsCivil || [];
    } else if(this.laboralCaseSelected && this.hasLaboral && this.contentShow === 'laboral') {
      return this.navTabsLaboral || [];
    } else if(this.cobranzaCaseSelected && this.hasCobranza && this.contentShow === 'cobranza') {
      return this.navTabsCobranza || [];
    } else {
      return [];
    }
  }

  loadTabData(): void {
    if(this.civilCaseSelected && this.hasCivil && this.contentShow === 'civiles') {
      for(const tab of this.navTabsCivil) {
        tab.content = [];
        if(tab.title === 'Historia') {
          this.civilCaseSelected?.details?.Historia?.forEach((historia: any) => {
            tab.content.push({
              folio: historia["Folio"],
              etapa: historia["Etapa"],
              tramite: historia["Trámite"],
              descTramite: historia["Desc. Trámite"],
              fechaTramite: historia["Fec. Trámite"],
              foja: historia["Foja"]
            });
          });
        } else if(tab.title === 'Litigantes') {
          this.civilCaseSelected?.details?.Litigantes?.forEach((litigante: any) => {
            tab.content.push({
              participante: litigante["Participante"],
              rut: litigante["Rut"],
              razonSocial: litigante["Nombre o Razón Social"]
            });
          });
        } else if(tab.title === 'Notificaciones') {
          this.civilCaseSelected?.details?.Notificationes?.forEach((notificacion: any) => {
            tab.content.push({
              rol: notificacion["ROL"],
              estNotif: notificacion["Esti. Notif."],
              tipoNotif: notificacion["Tipo Notif."],
              fechaTramite: notificacion["Fecha Trámite"],
              tipoPart: notificacion["Tipo Part."],
              nombre: notificacion["Nombre"],
              tramite: notificacion["Trámite"]
            });
          });
        }
      }
    } else if(this.laboralCaseSelected && this.hasLaboral && this.contentShow === 'laboral') {
      //return this.navTabsLaboral || [];
      for(const tab of this.navTabsLaboral) {
        tab.content = [];
        if(tab.title === 'Movimientos') {
          this.laboralCaseSelected?.details?.Movimientos?.forEach((movimiento: any) => {
            tab.content.push({
              folio: movimiento["Folio"],
              etapa: movimiento["Etapa"],
              tramite: movimiento["Trámite"],
              descTramite: movimiento["Desc. Trámite"],
              fechaTramite: movimiento["Fec. Trámite"],
              estado: movimiento["Estado"]
            });
          });
        } else if(tab.title === 'Litigantes') {
          this.laboralCaseSelected?.details?.Litigantes?.forEach((litigante: any) => {
            tab.content.push({
              abogDefensor: litigante["Abog. Defensor"],
              sujeto: litigante["Sujeto"],
              rut: litigante["Rut"],
              persona: litigante["Persona"],
              razonSocial: litigante["Nombre o Razón Social"]
            });
          });
        } else if(tab.title === 'Notificaciones') {
          this.laboralCaseSelected?.details?.Notificationes?.forEach((notificacion: any) => {
            tab.content.push({
              estNotif: notificacion["Estado Notif."],
              rit: notificacion["RIT."],
              ruc: notificacion["RUC"],
              fechaTramite: notificacion["Fecha Trámite"],
              tipoParte: notificacion["Tipo Part."],
              nombre: notificacion["Nombre"],
              tramite: notificacion["Trámite"],
              obsFallida: notificacion["Obs. Fallida"]
            });
          });
        } else if(tab.title === 'Materias') {
          this.laboralCaseSelected?.details?.Materias?.forEach((materia: any) => {
            tab.content.push({
              codigo: materia["Código"],
              glosaMateria: materia["Glosa de Materia"]
            });
          });
        }
      }
    } else if(this.cobranzaCaseSelected && this.hasCobranza && this.contentShow === 'cobranza') {
      //return this.navTabsCobranza || [];
      for(const tab of this.navTabsCobranza) {
        tab.content = [];
        if(tab.title === 'Historia') {
          this.cobranzaCaseSelected?.details?.Historia?.forEach((historia: any) => {
            tab.content.push({
              etapa: historia["Etapa"],
              tramite: historia["Trámite"],
              descTramite: historia["Desc. Trámite"],
              estadoFirma: historia["Estado Firma"],
              fechaTramite: historia["Fec. Trámite"],
              georreferencia: historia["Cuaderno"]
            });
          });
        } else if(tab.title === 'Litigantes') {
          this.cobranzaCaseSelected?.details?.Litigantes?.forEach((litigante: any) => {
            tab.content.push({
              sujeto: litigante["Participante"],
              rut: litigante["Rut"],
              persona: litigante["Persona"],
              razonSocial: litigante["Nombre o Razón Social"]
            });
          });
        } else if(tab.title === 'Notificaciones') {
          this.cobranzaCaseSelected?.details?.Notificationes?.forEach((notificacion: any) => {
            tab.content.push({
              tipoNotif: notificacion["Tipo Notif."],
              estNotif: notificacion["Esti. Notif."],
              fechaNotif: notificacion["Fec. Notif"],
              fechaTramite: notificacion["Fecha Trámite"],
              tramite: notificacion["Trámite"],
              tipPart: notificacion["Tipo Part."],
              nombre: notificacion["Nombre"]
            });
          });
        }
      }
    }
  }

  scrollToId(id: string): void {
    if(id) {
      // esperar un segundo antes de hacer scroll
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        } else {
          console.error(`Element with id ${id} not found`);
        }
      }, 1000);
    }
  }

  volverAlListado(id: string): void {
    if(id) {
      const idRow = 'row-'+id;
      const element = document.getElementById(idRow);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        this.highlightRowTemporarily(idRow);
      } else {
        console.error(`Element with id ${idRow} not found`);
      }
    }
  }

  highlightRowTemporarily(rowId: string) {
    this.highlightedRowId = rowId;

    setTimeout(() => {
      this.highlightedRowId = null;
    }, 2000); // 2 segundos
  }

  redireccion(): void {
    window.open('https://oficinajudicialvirtual.pjud.cl/includes/sesion-consultaunificada.php', '_blank');
  }

  handlePageEvent(event: any): void {
    if(this.paginated && this.idTransaccion) {
      const pagina = event.pageIndex + 1; // pageIndex is zero-based
      const tamanoPagina = event.pageSize; // pageSize is the number of items per page
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
      this.llamadaApi(pagina, tamanoPagina);
    }
  }

  llamadaApi(pagina: number, tamanoPagina: number): void {
    this.spinner.show();
    this._poderJudicialService.getReport(this.idTransaccion, pagina, tamanoPagina)
    .subscribe(
      (data) => {
        this.spinner.hide();        
        if (!data || Object.keys(data).length === 0) {
          this.alertService.error('Ha ocurrido un error al intentar validar el reporte.');
          this.volver.emit();
        } else {
          this.content = data;
          this.setContent();
        }
      },
      ({error}) => {
        this.alertService.error(error.message || 'Ha ocurrido un error al intentar obtener el reporte');
        this.spinner.hide();
        this.volver.emit();
      }
    );
  }

}
